(function () {
  'use strict';

  /* @ngdoc object
   * @name rosterChecking
   * @description
   *
   */
  angular
    .module('rosterChecking', [
      'ui.router'
    ]);
}());
